export const prepareMentionableData = (
  isRecall,
  hasPlum,
  hasReviews,
  pmsType,
  pmsVersion,
  isTemplate,
) => {
  const BASE_DATA = isTemplate
    ? [
        { name: 'patient_first_name' },
        { name: 'patient_last_name' },
        { name: 'patient_full_name' },
        { name: 'practice_name' },
      ]
    : [
        { name: 'patient_first_name' },
        { name: 'patient_last_name' },
        { name: 'patient_full_name' },
        { name: 'appointment_date' },
        { name: 'practice_name' },
        { name: 'website' },
        { name: 'location_street_address' },
        { name: 'location_secondary_address' },
        { name: 'location_name' },
        { name: 'location_city' },
        { name: 'location_state' },
        { name: 'location_zip' },
        { name: 'location_phone_number' },
      ]

  if (isTemplate) {
    return BASE_DATA
  }

  if (hasPlum) {
    BASE_DATA.push({ name: 'plum_appt_url' })
  }

  if (!(pmsType === 'topsOrtho' && pmsVersion && pmsVersion < 6)) {
    BASE_DATA.push({ name: 'patient_preferred_name' })
  }

  if (hasReviews) {
    BASE_DATA.push({ name: 'thumbs_up_thumbs_down' })
    BASE_DATA.push({ name: 'stars' })
    BASE_DATA.push({ name: 'location_facebook_url' })
    BASE_DATA.push({ name: 'location_google_url' })
    BASE_DATA.push({ name: 'location_yelp_url' })
  }

  if (isRecall) return BASE_DATA

  return pmsType === 'OrthoTrac'
    ? BASE_DATA.concat({ name: 'appointment_time' })
    : BASE_DATA.concat(
        { name: 'doctor_first_name' },
        { name: 'doctor_last_name' },
        { name: 'doctor_full_name' },
        { name: 'appointment_time' },
      )
}



// WEBPACK FOOTER //
// ./src/services/draft-state/mentionable.js